var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "_flexcol _gap-4 _gap-6--l" },
    [
      _vm._l(_vm.firstTwoUpdates, function (update) {
        return _c(
          "backer-center-update-feed-card",
          _vm._b(
            { key: update.projectUpdateID },
            "backer-center-update-feed-card",
            update,
            false
          )
        )
      }),
      _vm._v(" "),
      _c("backer-center-project-recommendations-section", {
        attrs: { "extra-large-screen-visible-items-count": 3 },
      }),
      _vm._v(" "),
      _vm._l(_vm.remainingUpdates, function (update) {
        return _c(
          "backer-center-update-feed-card",
          _vm._b(
            {
              key: update.projectUpdateID,
              attrs: {
                "data-qa": `updates-feed-card:${update.projectUpdateID}`,
              },
            },
            "backer-center-update-feed-card",
            update,
            false
          )
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }